var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card-company-table",attrs:{"no-body":""}},[_c('b-card-header',[_c('b-skeleton',{attrs:{"animation":"wave","width":"20%"}})],1),_c('b-skeleton-table',{attrs:{"rows":7,"columns":10,"table-props":{ bordered: true, striped: true }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }